import makeStyles from '@material-ui/core/styles/makeStyles';
import { mercury, white } from '../../../../constants/Colors';

export const styleVariables = {
    inputLabelShrinkScaleFactor: 1,
};

const asideWidth = 300;
const spaceBetween = 20;

export default makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        marginBottom: '80px',
    },
    tipContainer: {
        maxWidth: 575,
        display: 'flex',
        alignItems: 'flex-start',

        '& .balloon': {
            marginTop: 0,
        },

        '& .balloon p': {
            fontSize: '15px',
        },
    },
    mainContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        '& > *': {
            boxSizing: 'border-box',
        },
    },
    main: {
        background: white,
        width: '100%',
        border: `1px solid ${mercury}`,
        padding: '0 40px',
        '& > div:not(:last-child)': {
            borderBottom: `1px solid ${mercury}`,
        },
    },
    aside: {
        width: asideWidth,
        marginLeft: spaceBetween,
        position: 'sticky',
        top: 70,
    },
}));
